import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../ui/SectionHeading';

interface ProcessStep {
  number: number;
  title: string;
  description: string;
}

interface ProcessSectionProps {
  heading: string;
  subtitle?: string;
  steps: ProcessStep[];
  center?: boolean;
}

const ProcessSection: React.FC<ProcessSectionProps> = ({ 
  heading, 
  subtitle, 
  steps,
  center = true
}) => {
  return (
    <section className="py-16 md:py-24 bg-background-alt">
      <div className="container-custom">
        <SectionHeading 
          title={heading} 
          subtitle={subtitle}
          center={center}
        />
        
        <div className="mt-12">
          {steps.map((step, index) => (
            <motion.div 
              key={step.number}
              className={`flex flex-col md:flex-row mb-8 md:mb-16 ${
                index % 2 !== 0 ? 'md:flex-row-reverse' : ''
              }`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true, margin: "-100px" }}
            >
              <div className="flex-shrink-0 flex items-center justify-center mb-6 md:mb-0">
                <div className="w-20 h-20 md:w-24 md:h-24 bg-primary rounded-full flex items-center justify-center text-white text-3xl md:text-4xl font-bold">
                  {step.number}
                </div>
              </div>
              <div className={`md:flex-1 ${index % 2 !== 0 ? 'md:pr-8' : 'md:pl-8'}`}>
                <h3 className="text-2xl font-bold text-primary mb-4">{step.title}</h3>
                <p className="text-secondary">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;